import React, { Fragment, PureComponent } from 'react';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import PropTypes from 'prop-types';
import Banner from './banner';
import TabList from './tablist';
import { Grounds } from '@ifeng-fe/client_grounds';
import { QQShare } from 'ThreeTerminal_mobile_dynamic';

// window.grounds = {};

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        if (window?.grounds) {
            Grounds.pageStat({
                id: 'finance24hour',
            });
        }
    }

    render() {
        const {
            content: { banner },
        } = this.props;
        const qqShareCofig = {
            title: banner.shareTitle || '凤凰全球快报',
            img:
                banner.shareImage ||
                'https://p0.ifengimg.com/2019_19/7812F0690848DF15F2FA0248CE701CA0A823E558_w300_h300.png',
            desc: banner.shareBref || '24小时全球财经速递',
            cb: () => {
                console.log('分享成功');
            },
        };

        return (
            <Fragment>
                <Chip title="顶部banner图" type="struct" id="230114" groupName="顶部banner" content={banner}>
                    <Banner content={banner} />
                </Chip>
                <TabList />
                <QQShare content={qqShareCofig} />
                <ChipEdit transform={transform} />
            </Fragment>
        );
    }
}

export default Layout;
